import $ from 'jquery';

class TabSpa {
  constructor() {
    document.addEventListener('DOMContentLoaded', this.#init.bind(this));
  }

  #init() {
    this.hideForms();
    const select = $('#spa_selected').on('change', this.handleChange.bind(this));

    if (select.val()) {
      this.showFrom(select.val());
    }
  }

  hideForms() {
    $('.spa-form').hide();
  }

  showFrom(formId) {
    const form = $('#spa-form-' + formId);

    if (form.length) {
      form.show();
    }
  }

  handleChange(event) {
    this.hideForms();
    this.showFrom(event.target.value);
  }
}

export default TabSpa;
